import util from '../util'

let controller = 'OperadorOnboardingAssociadoParceiro'
export default Object.assign({}, util.GetCrud(controller, null), {
  ListarParceiroOperador: function (codigoOperador) {
    return util.Axios.Get(controller + `/${codigoOperador}`)
  },
})
